import { render, staticRenderFns } from "./UsuarioDataV.vue?vue&type=template&id=56fa463e"
import script from "./UsuarioDataV.vue?vue&type=script&lang=js"
export * from "./UsuarioDataV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports